
















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import Report from "../../models/report/Report";
import {Icon} from "@/helpers/icons";
import AsiCard from "../common/AsiCard.vue";
import ReportUpdateDialogReportLines from "@/components/report/ReportUpdateDialogReportLines.vue";
import ReportLinesList from "@/components/reportLine/ReportLinesList.vue";
import {Permissions, ReportState} from "@/helpers/constants";

@Component({
	components: {ReportLinesList, ReportUpdateDialogReportLines, AsiCard}
})
export default class ReportCardReportLines extends Vue {

	@Prop({type: Object, default: null})
	public report!: Report | null;

	@Prop({type: String, default: Icon.edit})
	public actionButtonIcon!: string;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get canBeEdited(): boolean {
		if (this.report === null) return false;
		return (this.isBilling || this.isCheckReports) && this.report.state !== ReportState.locked;
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isCheckReports(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCheckReports);
	}

	@Emit('reportChanged')
	public reportChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
